import { observable, action, makeObservable } from "mobx"

class FullPageStore {
  currentSection = 0
  direction = null

  constructor() {
    makeObservable(this, {
      currentSection: observable,
      direction: observable,
      increment: action,
      decrement: action,
    })
  }

  increment() {
    this.IndexScrollY += 1
  }

  decrement() {
    this.IndexScrollY -= 1
  }
}

export default new FullPageStore()
